import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { LineChart } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';

const buildRollingAvgData = (rollingAvgData, split, name) => {
    const data = rollingAvgData.filter((d) => d.split === split && d.value !== null && d.gamedate !== null)
        .map((d) => ([moment(d.gamedate).valueOf(), Number(d.value.toFixed(2))]));
    return { name, data };
};

const ReceivingRollingAvg = ({ rollingAvgData, minY, maxY }) => {
    const { t: translate } = useTranslation();
    const overallSeriesData = buildRollingAvgData(rollingAvgData, 'overall', translate('components.receiving-rolling.overall'));
    const h2hSeriesData = buildRollingAvgData(rollingAvgData, 'h2h', translate('components.receiving-rolling.h2h'));
    const seriesData = [
        overallSeriesData,
        h2hSeriesData,
    ];
    return (<LineChart seriesData={seriesData} isDateX dateFormatX="%B %d" showLegend minY={minY} maxY={maxY} legendposition="below" />);
};

ReceivingRollingAvg.propTypes = {
    rollingAvgData: PropTypes.arrayOf(PropTypes.shape({
        gamedate: PropTypes.string,
        value: PropTypes.number,
        week: PropTypes.number,
    })).isRequired,
    minY: PropTypes.number,
    maxY: PropTypes.number,
};

ReceivingRollingAvg.defaultProps = {
    minY: undefined,
    maxY: undefined,
};

export default ReceivingRollingAvg;
